import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListExchangeRates = (params) => {
    return axios.get(`${backendHost}/api/admin/exchange-rates`, {params});
};

export {
    getListExchangeRates
}